import { put, all, takeLatest } from 'redux-saga/effects';
import _data from '../utils/_data';
import '../app-actions';

import { getAction } from '../saga';

export function* getPlans(action) {
    // todo: real API endpoint
    yield getAction(action, `${Project.api}/subscriptions/plans`, 'GET_PLANS');
}

export default [
    takeLatest(Actions.GET_PLANS, getPlans),
];
